// Get the container
const slideContainerUNLook1 = document.querySelector('.UNLook1');

// URLs for desktop images
const desktopImageUrlsUNLook1 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/UNODesktop_1.png?v=1731482258',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/UNDesktop_2.jpg?v=1731518911'
];

// URLs for mobile images
const mobileImageUrlsUNLook1 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/UNMobile_1.jpg?v=1731519879',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/UnoMobile_2.png?v=1731482267',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/UnoMobile_3.png?v=1731482268'
];

// Function to determine screen size and load appropriate images
function loadImagesUNLook1() {
    const isMobile = window.innerWidth <= 768;
    console.log('isMobile:', isMobile); // Log whether the device is identified as mobile

    // Clear the container
    slideContainerUNLook1.innerHTML = '';

    if (isMobile) {
        console.log('Loading mobile images'); // Log the action of loading mobile images
        mobileImageUrlsUNLook1.forEach((url, index) => {
            const mobileImage = document.createElement('img');
            mobileImage.src = `${url}?cache_buster=${Date.now()}`; // Force cache busting
            mobileImage.alt = `Mobile image ${index + 1}`;
            mobileImage.className = 'mobile-image-UNLook1';
            slideContainerUNLook1.appendChild(mobileImage);
        });
    } else {
        console.log('Loading desktop images'); // Log the action of loading desktop images
        desktopImageUrlsUNLook1.forEach((url, index) => {
            const desktopImage = document.createElement('img');
            desktopImage.src = `${url}?cache_buster=${Date.now()}`; // Force cache busting
            desktopImage.alt = `Desktop image ${index + 1}`;
            desktopImage.className = 'desktop-image-UNLook1';
            slideContainerUNLook1.appendChild(desktopImage);
        });
    }
}

// Throttle function to avoid excessive firing on resize
function throttle(func, delay) {
    let timeoutId;
    return function () {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func();
        }, delay);
    };
}

// Call the function initially
document.addEventListener("DOMContentLoaded", function() {
    loadImagesUNLook1();

    // Listen for window resize events to update images if necessary
    window.addEventListener('resize', throttle(loadImagesUNLook1, 500));

    // Set the target end time (June 6, 2024, at 11:00 AM ET)
    const targetEndTimeUNLook1 = new Date('2024-06-06T11:00:00-04:00').getTime();

    function updateCountdownUNLook1() {
        const currentTime = new Date().getTime();
        const timeDifference = targetEndTimeUNLook1 - currentTime;

        // Check if the countdown has ended
        if (timeDifference <= 0) {
            document.getElementById('countdown-UNLook1').textContent = "Ready!";
            return;
        }

        const hours = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        document.getElementById('countdown-UNLook1').textContent = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        setTimeout(updateCountdownUNLook1, 1000);
    }

    updateCountdownUNLook1();
});
